import React, { useCallback } from "react";

import { useRouter } from "./router";

export const RouterLink = ({
  children,
  as: Component = "span",
  href,
  onClick = () => {},
  ...rest
}) => {
  const router = useRouter();

  const clickHandler = useCallback(() => {
    onClick();
    router.push(href);
  }, [href, onClick, router]);

  return (
    <Component {...rest} onClick={clickHandler}>
      {children}
    </Component>
  );
};
